var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00732422H513V341.996H0V-0.00732422Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.478 134.744L384.75 140.32L368.021 134.744L362.445 120.804L368.021 106.864H401.478L395.902 120.804L401.478 134.744Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.717 134.744V196.081C345.717 225.96 384.75 235.114 384.75 235.114C384.75 235.114 423.783 225.959 423.783 196.081V134.744H345.717Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.236 210.611C358.831 229.033 384.75 235.114 384.75 235.114C384.75 235.114 410.67 229.033 420.264 210.611L384.75 151.473L349.236 210.611Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.783 195.462L384.75 134.744L345.717 195.462V196.081C345.717 201.61 347.056 206.429 349.236 210.612L384.75 155.368L420.264 210.612C422.443 206.429 423.783 201.612 423.783 196.081V195.462Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 -0.00732422V30.6054L211.245 55.7534H256.5V115.228H197.282L256.5 148.127V170.989H229.768L156.13 130.083V170.989H100.37V122.321L12.7689 170.989H0V140.375L45.2552 115.228H0V55.7534H59.2184L0 22.8432V-0.00732422H26.7321L100.37 40.8974V-0.00732422H156.13V48.6595L243.731 -0.00732422H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 -0.0102539H112.219V69.4572H0V101.52H112.219V170.989H144.281V101.52H256.5V69.4572H144.281V-0.0102539Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 115.228L256.5 170.989V155.221L184.513 115.228H156.13Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 115.228L256.5 170.989V155.221L184.513 115.228H156.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 115.228L256.5 170.989V155.221L184.513 115.228H156.13ZM71.9863 115.228L0 155.221V170.989L100.37 115.228H71.9863Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 55.7504L0 -0.0102539V15.7575L71.9873 55.7504H100.37Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 55.7504L0 -0.0102539V15.7575L71.9873 55.7504H100.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 55.7504L0 -0.0102539V15.7575L71.9873 55.7504H100.37ZM184.514 55.7504L256.5 15.7575V-0.0102539L156.13 55.7504H184.514Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPn);
export default __webpack_public_path__ + "static/media/PN.fcf249381b97453bd0092ab0f9008a51.svg";
export { ForwardRef as ReactComponent };